export default "2ad39f526e9f96bb.svg"